import { useState } from "react";
import tooths21 from "../../assets/img/tooths/BB_21.png";
import tooths22 from "../../assets/img/tooths/BB_22.png";
import tooths23 from "../../assets/img/tooths/BB_23.png";
import tooths24 from "../../assets/img/tooths/BB_24.png";
import tooths25 from "../../assets/img/tooths/BB_25.png";
import tooths26 from "../../assets/img/tooths/BB_26.png";
import tooths27 from "../../assets/img/tooths/BB_27.png";
import tooths28 from "../../assets/img/tooths/BB_28.png";

const dentalList = [
	{ image: tooths21, dental: 21, name: 1 },
	{ image: tooths22, dental: 22, name: 2 },
	{ image: tooths23, dental: 23, name: 3 },
	{ image: tooths24, dental: 24, name: 4 },
	{ image: tooths25, dental: 25, name: 5 },
	{ image: tooths26, dental: 26, name: 6 },
	{ image: tooths27, dental: 27, name: 7 },
	{ image: tooths28, dental: 28, name: 8 },
];

const dentalChildList = [
	{ image: tooths21, dental: 61, name: "A" },
	{ image: tooths22, dental: 62, name: "B" },
	{ image: tooths23, dental: 63, name: "C" },
	{ image: tooths24, dental: 64, name: "D" },
	{ image: tooths25, dental: 65, name: "E" },
];

export default function ChartTow({
	chart,
	handleSetDentalList,
	handleRemoveDentalList,
	list,
}) {
	const findDental = (dentalNumber) => {
		let flag = false;
		if (!chart) return false;
		chart.map((item) => {
			if (dentalNumber == item.d_num) {
				flag = true;
			}
		});
		return flag;
	};

	const handleSelectShowNot = (e, checkFlag, id) => {
		// select tooth
		if (!list.find((e) => e === id)) {
			// setList([...list, id]);
			handleSetDentalList(id);
		} else {
			// remove tooth
			// setList(list.filter((item) => item !== id));
			handleRemoveDentalList(id);
		}

		// show notfication
		if (checkFlag) {
			const el = e.target.parentElement.lastChild;
			[...document.querySelectorAll(".dental-chart__charts_images__notif")].map(
				(item) => {
					item.classList.remove("show");
				},
			);
			el.classList.add("show");
			window.onclick = (e) => handleHideNot(e, el);
		}
	};

	// hide notification
	const handleHideNot = (e, el) => {
		if (!e.target.closest(".dental-chart__charts_images__item")) {
			// console.log(e.target);
			el.classList.remove("show");
		}
	};

	return (
		<div className="chart">
			{dentalList.map((item) => {
				let checkFlag = findDental(item.dental);
				return (
					<div
						key={item.dental}
						className={`chart__item chart__item-tow-${item.dental} ${
							list.find((e) => e === item.dental) ? "green-filter" : ""
						}`}
						onClick={(e) => handleSelectShowNot(e, checkFlag, item.dental)}
					>
						<span>{item.name}</span>
						{/* <img src={item.image} className={checkFlag ? "red-filter" : ""} /> */}
						{checkFlag ? (
							<div className="dental-chart__charts_images__notif">
								{chart
									.filter((item2) => item2.d_num == item.dental)
									.map((item3) => (
										<div>
											<p>
												<span>({item3.id_dental_chart})</span>
											</p>
											{"-"}
											<p>
												<span>{item3.sdate}</span>
											</p>
											{" - "}
											<p>
												<span>{item3.n_technician}</span>{" "}
												<span>({item3.cp_technician})</span>
											</p>
											{" - "}
											<p>
												<span>{item3.n_expert}</span>{" "}
												<span>({item3.cp_expert})</span>
											</p>
											{" - "}
											<p>
												<span>{item3.ns}</span>
											</p>
											{" - "}
											<p>
												<span>{item3.nc}</span> <span>{item3.ncs}</span>
											</p>
										</div>
									))}
							</div>
						) : (
							<></>
						)}
					</div>
				);
			})}

			{dentalChildList.map((item) => {
				let checkFlag = findDental(item.dental);
				return (
					<div
						key={item.dental}
						className={`chart__item chart__child_item-tow-${item.dental} ${
							list.find((e) => e === item.dental) ? "green-filter" : ""
						}`}
						onClick={(e) => handleSelectShowNot(e, checkFlag, item.dental)}
					>
						<span>{item.name}</span>
						{/* <img src={item.image} className={checkFlag ? "red-filter" : ""} /> */}
						{checkFlag ? (
							<div className="dental-chart__charts_images__notif">
								{chart
									.filter((item2) => item2.d_num == item.dental)
									.map((item3) => (
										<div>
											<p>
												<span>({item3.id_dental_chart})</span>
											</p>
											{"-"}
											<p>
												<span>{item3.sdate}</span>
											</p>
											{" - "}
											<p>
												<span>{item3.n_technician}</span>{" "}
												<span>({item3.cp_technician})</span>
											</p>
											{" - "}
											<p>
												<span>{item3.n_expert}</span>{" "}
												<span>({item3.cp_expert})</span>
											</p>
											{" - "}
											<p>
												<span>{item3.ns}</span>
											</p>
											{" - "}
											<p>
												<span>{item3.nc}</span> <span>{item3.ncs}</span>
											</p>
										</div>
									))}
							</div>
						) : (
							<></>
						)}
					</div>
				);
			})}
		</div>
	);
}
